import {Injectable} from '@angular/core';
import {CanActivate, Router, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {environment} from '../../../../src/environments/environment';
import {EnvsEnum} from '../../../../src/environments/environment.interface';
import {DataService} from 'shared/_services/data.service';
import {JOURNAL_PATH, ROOT_PATH, VIEW_PATH} from 'shared/magic';

@Injectable({
	providedIn: 'root'
})
export class PreprodDisabledGuard implements CanActivate {
	constructor(private data: DataService, private router: Router) {}

	getLastCitizenPath = (): UrlTree =>
		this.router.createUrlTree([
			ROOT_PATH,
			JOURNAL_PATH,
			VIEW_PATH,
			this.data.getLocalSnapshot('journal.lastCitizenId')
		])
	canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		const citizenId = this.data.getLocalSnapshot('journal.lastCitizenId');
		if ((environment.name === EnvsEnum.preprod || environment.name === EnvsEnum.prod) && !citizenId) return false;
		if ((environment.name === EnvsEnum.preprod || environment.name === EnvsEnum.prod) && citizenId) return this.getLastCitizenPath();
		return true;
	}
}


